import React, { useState } from 'react';
import CloseIcon from '../../../../assets/icons/close.svg';
import { isEmptyObject } from '../../../../utils';
import { AuthenticatedPUTRequest } from '../../../../utils';

const GuardianDetails = (props) => {
    const { data, isStudent, setState, onError, onClose } = props;
    const [loading, setLoading] = useState(false);
    const [guardianInformation, setGuardianInformation] = useState(data);

    const onSubmit = async (id, updatedInformation) => {
        const { data, success } = await AuthenticatedPUTRequest(
            isStudent ? `students/${id}` : `applicants/${id}`,
            updatedInformation,
        );
        setLoading(false);
        onClose();
        if (!success) {
            onError('براہ کرم دوبارہ کوشش کریں۔');
        } else {
            setState(data);
        }
    };

    const onUpdate = () => {
        setLoading(true);
        var updatedInformation = {};
        for (let key in guardianInformation) {
            if (key !== 'branch' && key !== 'class_room') {
                if (guardianInformation[key] !== data[key]) {
                    updatedInformation[key] = guardianInformation[key];
                }
            }
        }
        if (!isEmptyObject(updatedInformation)) {
            onSubmit(guardianInformation.id, updatedInformation);
        } else {
            setLoading(false);
            onClose();
        }
    };

    return (
        <div
            className='flex column justifyCenter alignCenter'
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1000,
                background: 'rgba(0,0,0,0.7)',
            }}
        >
            <div
                style={{
                    background: '#ffffff',
                    height: 650,
                    maxHeight: 650,
                    width: 980,
                    borderRadius: 8,
                }}
            >
                <div className='h-100 w-100' style={{ overflow: 'auto', position: 'relative' }}>
                    <div
                        className='flex justifyBetween alignCenter w-100'
                        style={{
                            borderBottom: '1px solid #E0E0E0',
                            padding: '20px 16px 8px',
                            height: 72,
                        }}
                    >
                        <h2 className='flex alignCenter w-100' style={{ color: '#009688' }}>
                            سرپرست کی معلومات ترمیم کریں
                        </h2>

                        <img
                            src={CloseIcon}
                            alt='close_icon'
                            height={32}
                            width={32}
                            onClick={props.onClose}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>

                    <div
                        className='flex column justifyCenter alignCenter urdu'
                        style={{ padding: 20 }}
                    >
                        <div className='flex column w-100'>
                            <div className='flex justifyBetween alignCenter'>
                                {/* name */}
                                <div className='form-container urdu'>
                                    <label htmlFor='guardian_name'>
                                        امیدوار کے سرپرست کا نام
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        name='guardian_name'
                                        value={guardianInformation['guardian_name']}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setGuardianInformation({
                                                    ...guardianInformation,
                                                    guardian_name: e.target.value,
                                                });
                                            } else {
                                                setGuardianInformation({
                                                    ...guardianInformation,
                                                    guardian_name:
                                                        guardianInformation['guardian_name'],
                                                });
                                            }
                                        }}
                                    />
                                </div>
                                {/* father name */}
                                <div className='form-container urdu'>
                                    <label htmlFor='guardian_father_name'>
                                        سرپرست کے والد کا نام
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        name='guardian_father_name'
                                        value={guardianInformation['guardian_father_name']}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setGuardianInformation({
                                                    ...guardianInformation,
                                                    guardian_father_name: e.target.value,
                                                });
                                            } else {
                                                setGuardianInformation({
                                                    ...guardianInformation,
                                                    guardian_father_name:
                                                        guardianInformation['guardian_father_name'],
                                                });
                                            }
                                        }}
                                    />
                                </div>
                                {/* cnic */}
                                <div className='form-container english'>
                                    <label htmlFor='guardian_cnic'>
                                        سرپرست کا شناختی کارڈ نمبر
                                        <span className='required'>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        name='guardian_cnic'
                                        value={guardianInformation['guardian_cnic']}
                                        placeholder='xxxxxxxxxxxxx'
                                        maxLength={13}
                                        style={{
                                            height: 44,
                                            fontSize: 18,
                                            padding: 4,
                                            fontFamily: 'CircularStd',
                                        }}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setGuardianInformation({
                                                    ...guardianInformation,
                                                    guardian_cnic: e.target.value,
                                                });
                                            } else {
                                                setGuardianInformation({
                                                    ...guardianInformation,
                                                    guardian_cnic:
                                                        guardianInformation['guardian_cnic'],
                                                });
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div className='flex justifyBetween alignCenter'>
                                {/* mobile number */}
                                <div className='form-container english'>
                                    <label htmlFor='guardian_primary_phone_number'>
                                        سرپرست کا موبائل نمبر
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        name='guardian_primary_phone_number'
                                        placeholder='03xxxxxxxxx'
                                        maxLength={11}
                                        style={{
                                            height: 44,
                                            fontSize: 18,
                                            padding: 4,
                                            fontFamily: 'CircularStd',
                                        }}
                                        value={guardianInformation['guardian_primary_phone_number']}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setGuardianInformation({
                                                    ...guardianInformation,
                                                    guardian_primary_phone_number: e.target.value,
                                                });
                                            } else {
                                                setGuardianInformation({
                                                    ...guardianInformation,
                                                    guardian_primary_phone_number:
                                                        guardianInformation[
                                                            'guardian_primary_phone_number'
                                                        ],
                                                });
                                            }
                                        }}
                                    />
                                </div>
                                {/* alernative number */}
                                <div className='form-container english'>
                                    <label htmlFor='guardian_secondary_phone_number'>
                                        سرپرست کا دیگر موبائل نمبر
                                    </label>
                                    <input
                                        type='text'
                                        name='guardian_secondary_phone_number'
                                        placeholder='03xxxxxxxxx'
                                        maxLength={11}
                                        style={{
                                            height: 44,
                                            fontSize: 18,
                                            padding: 4,
                                            fontFamily: 'CircularStd',
                                        }}
                                        value={
                                            guardianInformation['guardian_secondary_phone_number']
                                        }
                                        onChange={(e) => {
                                            setGuardianInformation({
                                                ...guardianInformation,
                                                guardian_secondary_phone_number: e.target.value,
                                            });
                                        }}
                                    />
                                </div>
                                {/* relation with applicant */}
                                <div className='form-container urdu'>
                                    <label htmlFor='relation_with_guardian'>
                                        سرپرست کاامیدوار سے رشتہ
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        name='relation_with_guardian'
                                        value={guardianInformation['relation_with_guardian']}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setGuardianInformation({
                                                    ...guardianInformation,
                                                    relation_with_guardian: e.target.value,
                                                });
                                            } else {
                                                setGuardianInformation({
                                                    ...guardianInformation,
                                                    relation_with_guardian:
                                                        guardianInformation[
                                                            'relation_with_guardian'
                                                        ],
                                                });
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div className='flex justifyBetween alignCenter mb-32'>
                                {/* complete address */}
                                <div className='form-container urdu'>
                                    <label htmlFor='guardian_permanent_address'>
                                        (سرپرست کا مستقل پتا(صوبہ اور ضلع کے ساتھ )
                                        <span className='mlr required'>*</span>
                                    </label>
                                    <input
                                        type='text'
                                        name='guardian_permanent_address'
                                        style={{ height: 120 }}
                                        value={guardianInformation['guardian_permanent_address']}
                                        onChange={(e) => {
                                            if (e.target.value.length > 0) {
                                                setGuardianInformation({
                                                    ...guardianInformation,
                                                    guardian_permanent_address: e.target.value,
                                                });
                                            } else {
                                                setGuardianInformation({
                                                    ...guardianInformation,
                                                    guardian_permanent_address:
                                                        guardianInformation[
                                                            'guardian_permanent_address'
                                                        ],
                                                });
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div
                            className='flex justifyEnd alignCenter w-100'
                            style={{ height: 64, marginTop: 16 }}
                        >
                            <div className='flex justifyBetween alignCenter'>
                                <div
                                    className='flex justifyEnd alignCenter register_button'
                                    style={{ margin: '0 8px' }}
                                    onClick={() => onUpdate()}
                                >
                                    {loading ? (
                                        <div className='custom_loader' />
                                    ) : (
                                        <h3>{`محفوظ کریں`}</h3>
                                    )}
                                </div>
                                <div
                                    className='flex justifyEnd alignCenter delete_button'
                                    style={{ margin: '0 8px' }}
                                    onClick={() => onClose()}
                                >
                                    <h3>{`منسوخ کریں`}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GuardianDetails;
